
export default {
  methods: {
    handleReset() {
      const query = Object.entries(this.$route.query)
        .filter(([name]) => !this.$bedbuilder.defaultOptions[name])
        .reduce((acc, [name, value]) => ({ ...acc, [name]: value }), {});
      this.$router.push({ query });
      this.$store.dispatch("bedbuilder/closeBedbuilderReset");
    },
  },
};
